export default "__VITE_ASSET__DZ5VZXgG__"